import styled from 'styled-components';

export const ButtonPanel = styled.div`
  margin-bottom: 20px;
  display: flex;

  & > * {
    margin-right: 10px;
  }

  .align-right {
    margin: 0 0 0 auto;
  }

  .end-buttons {
    .btn {
      margin-left: 10px;
    }
  }
`;

export const Container = styled.div`
  .profile-image {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    background-size: cover;
    background-color: #eaeaea;
    background-position: center;
    border-radius: 100px;
  }
`;

export const Table = styled.table`
  text-align: center;
  margin-bottom: 0;

  td,
  th {
    vertical-align: middle;
  }

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/Administrators/styles.js